import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { useHandleShowDialogs } from 'forms/hooks';
import { useDispatch } from 'react-redux';

import SubmitButton from '@gef-ui/form-material/SubmitButton';
import { getLabelMessage } from '@gef-ui/localization/messages';

import { ComponentLoader } from 'components';
import fetch from 'features/common/fetch';
import newProduction from 'features/views/productionNew';
import { submitTypes } from 'features/views/productionNew/constants';
import { PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME } from 'features/views/productionNew/form';

const { urls } = fetch.constants;

const ActionButtons = ({ isClosed }) => {
	const dispatch = useDispatch();

	const handleSubmit = useCallback(
		(type) => () => {
			dispatch(newProduction.actions.createOrUpdateDocument(type));
		},
		[dispatch],
	);

	const url = urls.productionDocument;

	const handleShowDialogsForAddSubmit = useHandleShowDialogs({
		page: PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME,
		mapper: { name: ['firstName', 'surname', 'businessName'] },
		continueFn: handleSubmit(submitTypes.add),
	});

	const handleShowDialogsForAddAndCloseSubmit = useHandleShowDialogs({
		page: PRODUCED_PRODUCTION_NEW_MODAL_FORM_NAME,
		mapper: { name: ['firstName', 'surname', 'businessName'] },
		continueFn: handleSubmit(submitTypes.addAndClose),
	});

	return (
		<Grid container spacing={1} justifyContent="flex-end">
			<Grid size={4}>
				<ComponentLoader fetchStorePath={`${url}.${submitTypes.add}`} ignoreErrors>
					<SubmitButton
						variant="contained"
						onClick={handleSubmit(submitTypes.add)}
						onClickError={handleShowDialogsForAddSubmit}
						disabled={isClosed}
						fullWidth
						text={getLabelMessage('producedProductionNew:saveAndNext')}
					/>
				</ComponentLoader>
			</Grid>
			<Grid size={4}>
				<ComponentLoader fetchStorePath={`${url}.${submitTypes.addAndClose}`} ignoreErrors>
					<SubmitButton
						variant="contained"
						onClick={handleSubmit(submitTypes.addAndClose)}
						onClickError={handleShowDialogsForAddAndCloseSubmit}
						disabled={isClosed}
						fullWidth
						text={getLabelMessage('producedProductionNew:saveAndClose')}
					/>
				</ComponentLoader>
			</Grid>
		</Grid>
	);
};

ActionButtons.propTypes = {
	isClosed: PropTypes.bool,
};

export default ActionButtons;
